<span
  class="badge"
  [ngClass]="{ 'badge-warning': type === 'warning', 'badge-danger': type === 'danger', 'badge-primary': type === 'primary' }"
>
  <!-- {{ value }} -->
  {{ value | toBadgeLabel }}
</span>
